import PropTypes from 'prop-types';
import React, { useState } from 'react';

import defaultGetRouteWithVersion from './getRouteWithVersion';
import styles from './VersionDropdown.module.scss';

const VersionDropdown = ({ hide = false, getRouteWithVersion = defaultGetRouteWithVersion }) => {
  const apiVersions = typeof window !== 'undefined' ? devsite?.reference?.apiVersions : [];
  const version = typeof window !== 'undefined' ? devsite?.reference?.version : '';
  const [value, setValue] = useState(version);

  const handleSelection = (e) => {
    const version = e.target.value;
    setValue(version);
    window.location.assign(getRouteWithVersion(version));
  };

  //Limit the version dropdown to the staff users in the initial rollout.
  if (
    !apiVersions ||
    apiVersions.length === 0 ||
    !version ||
    hide ||
    !devsite?.user?.active_staff
  ) {
    return null;
  }

  return (
    <div className={styles.dropdown}>
      <div className={styles.displayText}>Display content for API version</div>
      <select
        value={value}
        onChange={handleSelection}
        data-testid="select"
        className={styles.selectOption}
      >
        {apiVersions.map((version) => (
          <option key={version} value={version} href={version} data-testid="select-option">
            {version}
          </option>
        ))}
      </select>
    </div>
  );
};

VersionDropdown.propTypes = {
  value: PropTypes.string,
  values: PropTypes.array,
  getRouteWithVersion: PropTypes.func,
  hide: PropTypes.bool,
};

export default VersionDropdown;
